export function LeftIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M17.5 21L10.5 14L17.5 7" stroke="#18191B" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function RightIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M10.5 7L17.5 14L10.5 21" stroke="#18191B" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function AddIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                opacity="0.5"
                data-figma-bg-blur-radius="50"
                d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
                fill="#CFD0D2"
            />
            <path d="M26 19.916H14M20.0185 13.916V25.916" stroke="#595C61" strokeWidth="1.81827" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <clipPath id="bgblur_0_7109_10820_clip_path" transform="translate(50 50)">
                    <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" />
                </clipPath>
                <clipPath id="bgblur_1_7109_10820_clip_path" transform="translate(45 45)">
                    <path d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function DownIcon(props: any) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                data-figma-bg-blur-radius="33.3333"
                d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
                fill="#DFE0E1"
            />
            <path
                d="M15.6172 17.2796C15.2472 16.9068 14.6475 16.9068 14.2775 17.2796C13.9075 17.6523 13.9075 18.2567 14.2775 18.6295L19.3301 23.7204C19.6968 24.09 20.2903 24.0937 20.6616 23.7286L25.7142 18.7617C26.0887 18.3935 26.0961 17.7892 25.7307 17.4119C25.3653 17.0345 24.7655 17.0271 24.391 17.3952L20.0082 21.7038L15.6172 17.2796Z"
                fill="#595C61"
            />
            <defs>
                <clipPath id="bgblur_0_7614_9923_clip_path" transform="translate(50 50)">
                    <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" />
                </clipPath>
                <clipPath id="bgblur_1_7614_9923_clip_path" transform="translate(28.3333 28.3333)">
                    <path d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" />
                </clipPath>
            </defs>
        </svg>
    );
}
export function FlashIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="37" height="46" viewBox="0 0 37 46" fill="none">
            <g opacity="0.6" filter="url(#filter0_f_7883_13619)">
                <path
                    d="M27.9446 23.7692C27.9446 28.7244 23.9275 32.7415 18.9723 32.7415C14.017 32.7415 10 28.7244 10 23.7692C10 18.8139 14.017 14.7969 18.9723 14.7969C23.9275 14.7969 27.9446 18.8139 27.9446 23.7692Z"
                    fill="#BEF8CF"
                />
            </g>
            <g opacity="0.6" filter="url(#filter1_f_7883_13619)">
                <path
                    d="M22.8949 20.6594C22.8949 22.9005 21.0782 24.7172 18.8371 24.7172C16.596 24.7172 14.7793 22.9005 14.7793 20.6594C14.7793 18.4183 16.596 16.6016 18.8371 16.6016C21.0782 16.6016 22.8949 18.4183 22.8949 20.6594Z"
                    fill="#C9FFDC"
                />
            </g>
            <path
                d="M16.893 37.5492C16.6266 37.9883 15.9512 37.7994 15.9512 37.2858V27.571C15.9512 27.2906 15.7239 27.0632 15.4435 27.0632H11.1413C10.7523 27.0632 10.5078 26.6438 10.6995 26.3053L20.6826 8.67635C20.9397 8.22238 21.6322 8.40484 21.6322 8.92655V19.8676C21.6322 20.148 21.8595 20.3753 22.1399 20.3753H26.4112C26.8069 20.3753 27.0505 20.8081 26.8452 21.1464L16.893 37.5492Z"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_f_7883_13619"
                    x="1.47003"
                    y="6.26691"
                    width="35.0052"
                    height="35.0052"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="4.26498" result="effect1_foregroundBlur_7883_13619" />
                </filter>
                <filter
                    id="filter1_f_7883_13619"
                    x="11.3267"
                    y="13.149"
                    width="15.0204"
                    height="15.0224"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="1.7263" result="effect1_foregroundBlur_7883_13619" />
                </filter>
            </defs>
        </svg>
    );
}
export function TimeIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M10.0205 17.4414C14.1625 17.4414 17.5203 14.0834 17.5205 9.94141C17.5203 5.79945 14.1625 2.44145 10.0205 2.44141C5.87863 2.44158 2.52068 5.79953 2.52051 9.94141C2.52055 11.0188 2.74889 12.0435 3.1582 12.9697L4.30176 11.0957C4.22692 10.7227 4.18752 10.3365 4.1875 9.94141C4.18768 6.72 6.7991 4.1076 10.0205 4.10742C13.242 4.10747 15.8543 6.71992 15.8545 9.94141C15.8543 13.1629 13.242 15.7744 10.0205 15.7744C9.4574 15.7744 8.91341 15.6937 8.39844 15.5449L7.52539 17.0156C8.30613 17.2911 9.14592 17.4414 10.0205 17.4414Z"
                fill="#3A3C3F"
            />
            <path
                d="M5.00875 17.7659C4.91933 17.9067 4.70138 17.8434 4.70138 17.6766V15.6042C4.70138 15.5121 4.62676 15.4375 4.53472 15.4375H3.605C3.47586 15.4375 3.39578 15.297 3.46162 15.1859L5.78023 11.2732C5.86665 11.1274 6.09028 11.1887 6.09028 11.3582V13.7083C6.09028 13.8004 6.1649 13.875 6.25695 13.875H7.17592C7.30736 13.875 7.38708 14.02 7.31663 14.131L5.00875 17.7659Z"
                fill="#3A3C3F"
            />
            <path d="M13.3958 10.583L9.81246 10.583L9.85223 5.91632" stroke="#3A3C3F" stroke-width="1.66667" stroke-linejoin="round" />
        </svg>
    );
}
export function OutPutIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="4.16602" y="4.16406" width="12.5" height="12.5" rx="1" stroke="#3A3C3F" stroke-width="1.66667" />
            <path
                d="M10.3994 11.6016C10.9517 11.6016 11.3994 12.0493 11.3994 12.6016V13.5898C11.3992 13.5962 11.3941 13.6014 11.3877 13.6016H9.41211C9.40555 13.6016 9.39962 13.5964 9.39941 13.5898V12.6016C9.39941 12.0493 9.84717 11.6016 10.3994 11.6016ZM8.92578 7.60156C9.02166 7.60156 9.09961 7.67951 9.09961 7.77539V10.4277C9.09961 10.5236 9.02166 10.6016 8.92578 10.6016H7.77344C7.67755 10.6016 7.59961 10.5236 7.59961 10.4277V7.77539C7.59961 7.67951 7.67755 7.60156 7.77344 7.60156H8.92578ZM13.0918 7.60156C13.1877 7.60156 13.2656 7.67951 13.2656 7.77539V10.4277C13.2656 10.5236 13.1877 10.6016 13.0918 10.6016H11.9395C11.8436 10.6016 11.7656 10.5236 11.7656 10.4277V7.77539C11.7656 7.67951 11.8436 7.60156 11.9395 7.60156H13.0918Z"
                fill="#3A3C3F"
            />
        </svg>
    );
}
export function LeftIcon2(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
                d="M7.15693 13.7272L1.14652 7.71683C0.95126 7.52157 0.95126 7.20499 1.14652 7.00973L7.15693 0.99932"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
            />
        </svg>
    );
}

export function RightIcon2(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
                d="M1.0003 13.7272L7.0107 7.71683C7.20597 7.52157 7.20597 7.20499 7.0107 7.00973L1.0003 0.99932"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
            />
        </svg>
    );
}

export function XStream(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="127" height="24" viewBox="0 0 127 24" fill="none">
            <g clip-path="url(#clip0_8059_816)">
                <path
                    d="M78.2038 10.1182C79.4407 10.1182 80.7134 9.1166 81.045 7.8775L81.7172 5.36569C82.0488 4.12883 81.3139 3.125 80.0771 3.125H69.3218L68.6764 5.5315H79.2951L78.7125 7.71169H68.0916L66.2363 14.6869H68.5801L69.8035 10.1182H72.871L76.2164 14.6869H79.6267L76.2835 10.1182H78.2038Z"
                    fill={props.color}
                />
                <path d="M104.05 3.125L94.9395 14.6869H97.5902L104.552 5.85192L106.779 14.6869H109.432L106.515 3.125H104.05Z" fill={props.color} />
                <path
                    d="M41.1611 7.70497L41.7437 5.52702H52.3556L52.9987 3.125H42.2904C41.0536 3.125 39.7809 4.12883 39.4493 5.36569L38.1788 10.107H48.7907L48.2081 12.2872H37.5962L36.9531 14.6869H47.6614C48.8982 14.6869 50.171 13.6831 50.5026 12.4463L51.773 7.70497H41.1611Z"
                    fill={props.color}
                />
                <path
                    d="M124.365 14.6869L126.863 5.36569C127.195 4.12883 126.46 3.125 125.223 3.125H113.618L110.52 14.6869H112.926L115.391 5.46204H118.738L116.274 14.6869H118.611L121.075 5.46204H124.423L121.958 14.6869H124.365Z"
                    fill={props.color}
                />
                <path d="M54.0312 5.52702H59.3484L56.8949 14.6869H59.2364L61.6921 5.52702H67.0093L67.6523 3.125H54.6765L54.0312 5.52702Z" fill={props.color} />
                <path d="M80.9004 14.689H93.8493L94.4901 12.2892H83.885L84.4698 10.109H95.075L95.7203 7.70703H82.7714L80.9004 14.689Z" fill={props.color} />
                <path d="M83.3555 5.52702H96.3044L96.9475 3.125H84.0008L83.3555 5.52702Z" fill={props.color} />
                <path d="M29.3672 10.109H35.8361L36.4791 7.70703H30.0125L29.3672 10.109Z" fill={props.color} />
                <path d="M15.7765 0H9.25391L14.952 7.70796L19.1107 4.50826L15.7765 0Z" fill={props.color} />
                <path d="M22.4229 17.8138H28.9456L23.7181 10.7422L19.2188 13.4825L22.4229 17.8138Z" fill={props.color} />
                <path d="M34.9211 0H26.7269L12.5591 10.8696H15.6602L0 24L26.8278 7.70572H23.6908L34.9211 0Z" fill="url(#paint0_linear_8059_816)" />
            </g>
            <defs>
                <linearGradient id="paint0_linear_8059_816" x1="32.9896" y1="-1.53233e-07" x2="0.0515337" y2="23.9754" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#EAC64C" />
                    <stop offset="0.554786" stop-color="#C09325" />
                    <stop offset="1" stop-color="#AF7D14" />
                </linearGradient>
                <clipPath id="clip0_8059_816">
                    <rect width="126.945" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
